import { buildApiURL, apiGet, apiPost, apiPut, apiDelete } from '@src/services/api';

/**
 * Customer Lists API Service
 * Handles all API calls related to customer lists management
 */

/**
 * Fetch customer lists for a specific premier access group
 * @param {string} premierAccessGroupId - The premier access group ID
 * @param {Object} params - Additional query parameters (search, page, etc.)
 * @returns {Promise} - API response with customer lists data
 */
export const fetchCustomerLists = (premierAccessGroupId, params = {}) => {
    const queryParams = {
         
        premier_access_group_id: premierAccessGroupId,
        ...params,
    };

    const url = buildApiURL('/api/v1/customer_lists', queryParams);
    return apiGet(url);
};

/**
 * Create a new customer list
 * @param {Object} listData - The customer list data to create
 * @returns {Promise} - API response with created list
 */
export const createCustomerList = (listData) => {
    const url = buildApiURL('/api/v1/customer_lists');
     
    return apiPost(url, { customer_list: listData });
};

/**
 * Update an existing customer list
 * @param {string} listId - The customer list ID
 * @param {Object} listData - The updated customer list data
 * @returns {Promise} - API response with updated list
 */
export const updateCustomerList = (listId, listData) => {
    const url = buildApiURL(`/api/v1/customer_lists/${listId}`);
     
    return apiPut(url, { customer_list: listData });
};

/**
 * Delete a customer list
 * @param {string} listId - The customer list ID to delete
 * @returns {Promise} - API response
 */
export const deleteCustomerList = (listId) => {
    const url = buildApiURL(`/api/v1/customer_lists/${listId}`);
    return apiDelete(url);
};

/**
 * Fetch a single customer list by ID
 * @param {string} listId - The customer list ID
 * @returns {Promise} - API response with customer list data
 */
export const fetchCustomerList = (listId) => {
    const url = buildApiURL(`/api/v1/customer_lists/${listId}`);
    return apiGet(url);
};
